import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: '', loadChildren: () => import('./entity/entity.module').then(m => m.EntityModule) },
];
